import { HelpCenter } from '@/components/sgwt/HelpCenter.tsx';
import { MiniFooter } from '@/components/sgwt/MiniFooter.tsx';

export function Footer() {
  return (
    <footer>
      <HelpCenter />
      <MiniFooter />
    </footer>
  );
}